/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Services_HeadingInputs */

const ja_playdata_home_services_heading = /** @type {(inputs: Playdata_Home_Services_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATAが提供するサービス`)
};

const en_playdata_home_services_heading = /** @type {(inputs: Playdata_Home_Services_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What PLAYDATA offers`)
};

/**
* | output |
* | --- |
* | "What PLAYDATA offers" |
*
* @param {Playdata_Home_Services_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_services_heading = /** @type {((inputs?: Playdata_Home_Services_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Services_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_services_heading(inputs)
	return en_playdata_home_services_heading(inputs)
});